import { getPermissionListHook } from '../../utils';

import { clientApi } from '../../configuration';

interface GetParams {
  userId: number | string;
}

const useStudentApplicationPermissions = getPermissionListHook({
  entityName: 'studentApplicationPermissions',
  apiResponseRootKey: 'studentApplicationAppSources',
  fetch: ({ userId }: GetParams) =>
    clientApi.getOCClient().helpers.user.users.id(userId).studentApplicationPermissions.find(),
});

// eslint-disable-next-line import/prefer-default-export
export { useStudentApplicationPermissions };
